export const DEFAULT_ORG_MAIN_TRAX_STATEMENT_ORDER = [
  'purpose',
  'problemSolved',
  'why',
  'promise',
  'vision',
  'mission',
  'coreValues',
  'cultureStatement',
  'valueCreated',
] as const;

export type OrgMainTraxStatementKey = typeof DEFAULT_ORG_MAIN_TRAX_STATEMENT_ORDER[number];

export const ORG_STATEMENT_HIDE_FIELD: Record<OrgMainTraxStatementKey, string> = {
  purpose: 'hide_purpose_in_main_trax',
  problemSolved: 'hide_problem_solved_in_main_trax',
  why: 'hide_why_in_main_trax',
  promise: 'hide_promise_in_main_trax',
  vision: 'hide_vision_in_main_trax',
  mission: 'hide_mission_in_main_trax',
  coreValues: 'hide_core_values_in_main_trax',
  cultureStatement: 'hide_culture_statement_in_main_trax',
  valueCreated: 'hide_value_created_in_main_trax',
};

export const ORG_STATEMENT_LABELS: Record<OrgMainTraxStatementKey, string> = {
  purpose: 'Purpose',
  problemSolved: 'Problem Solved',
  why: 'Why',
  promise: 'Promise',
  vision: 'Vision',
  mission: 'Mission',
  coreValues: 'Core Values',
  cultureStatement: 'Culture Statement',
  valueCreated: 'Value Created',
};

const DEFAULT_SET = new Set<string>(DEFAULT_ORG_MAIN_TRAX_STATEMENT_ORDER);

function asStringArray(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.map((item) => String(item));
  }
  if (typeof raw === 'string' && raw.trim() !== '') {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item));
      }
    } catch {
      return [];
    }
  }
  return [];
}

/** Normalize saved order; append any new default keys the org has not ordered yet. */
export function parseOrgMainTraxStatementOrder(raw: unknown): OrgMainTraxStatementKey[] {
  const seen = new Set<string>();
  const ordered: OrgMainTraxStatementKey[] = [];

  asStringArray(raw).forEach((key) => {
    if (DEFAULT_SET.has(key) && !seen.has(key)) {
      seen.add(key);
      ordered.push(key as OrgMainTraxStatementKey);
    }
  });

  DEFAULT_ORG_MAIN_TRAX_STATEMENT_ORDER.forEach((key) => {
    if (!seen.has(key)) {
      ordered.push(key);
    }
  });

  return ordered;
}

export function resolveOrgMainTraxStatementOrder(organization: any): OrgMainTraxStatementKey[] {
  return parseOrgMainTraxStatementOrder(organization?.main_trax_statement_order);
}
